/*
 * @Author: WLL
 * @Date: 2020-02-10 08:57:04
 * @LastEditors: WLL
 * @LastEditTime: 2020-04-10 17:00:31
 * @Description: file content
 */
import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "columns",
      description:
        "表头定义项，基本参数与el-table-columns一致，支持children定义嵌套表头，custom字段可使表格列使用自定模板，image(等)字段可使用内置表格类型，filterable可添加过滤器选项，ellipsis是否超出显示...(默认值为true，超出换行)",
      type: "Array",
      required: "True"
    },
    {
      prop: "data",
      description: "数据定义项，请保证属性定义与表头定义保持一致",
      type: "Array",
      required: "True"
    },
    {
      prop: "tableProps",
      description:
        "el-tables的属性定义项，其中highlight-hover为滚动时高亮当前行（true/false），highlight-current-row为选中时高亮当前行（true/false）,border是否有border，默认为false；cancelFill表示是否取消默认填充值，默认为false；beforeCurrentChange表示触发current-change事件之前的回调，返回false则阻止current-change事件触发",
      type: "Object"
    },
    {
      prop: "customFilter",
      description:
        "自定义的过滤函数，不填写则使用包含过滤, 参数为(data, filterConfig)",
      type: "Function"
    },
    {
      prop: "size",
      description: "表格尺寸",
      type: "String",
      required: "false",
      available: "medium, default, small"
    },
    {
      prop: "fillValue",
      description: "默认填充值",
      type: "String",
      default: "—"
    },
    {
      prop: "scrollImmediateCheck",
      description: "是否立即执行加载方法",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "scrollDisabled",
      description: "是否禁用",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "scrollDistance",
      description: "触发加载的距离阈值，单位为px",
      type: "Number",
      default: "10"
    }
  ],
  events: [
    {
      name: "$events",
      description: "支持全部el-tables事件"
    },
    {
      name: "infiniteScroll",
      description: "无限滚动事件"
    }
  ],
  methods: [
    {
      name: "clearSort",
      description: "清除表格排序属性"
    },
    {
      name: "clearFilter",
      description: "清除表格过滤属性"
    }
  ],
  slots: [
    {
      name: "default",
      description:
        "选项，数据为 { row, columns },会用于设置了 custom: true 的表格列的模板"
    }
  ]
};

export default DemoWrapper(Demo, DemoSource, config);
